export const checkingAssignment = {
  methods:{
    checkingCreatePermission (type) {
      if (
        (this.checkCreatePermission() &&
                type === 'General') ||
              (this.customCreateAction && type === 'Custom')
      ) {
        return true
      } else {
        return false
      }
    },
    checkingEditPermission (type) {
      if (
        (this.checkEditPermission() &&
                type === 'General') ||
              (this.customEditAction && type === 'Custom') ||
              (type === 'Shared' && this.checkEditPermission())
      ) {
        return true
      } else {
        return false
      }
    },
    checkingDeletePermission (type) {
      if (
        (this.checkDeletePermission() &&
                type === 'General') ||
              (this.customDeleteAction && type === 'Custom')
      ) {
        return true
      } else {
        return false
      }
    }
  }
}